<div style="padding-bottom: 24px">
    <p>{{ hinweisText }}</p>
    <canvas width="600" height="300" #signatureCanvas class="signature-pad-desktop-portrait"></canvas>
    <br />
    <button (click)="clear()" type="button" class="mat-focus-indicator mat-flat-button mat-button-base mat-accent"
        >L&ouml;schen</button
    >
    <button
        (click)="save()"
        [disabled]="signaturePad?.isEmpty()"
        color="accent"
        mat-button
        type="button"
        class="mat-focus-indicator mat-flat-button mat-button-base mat-accent"
        >Speichern
    </button>
</div>
